module.exports = "/assets/b37ff0bd93ee2019635db833c6f443ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DU.png
// module id = 1314
// module chunks = 0